import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Button, Grid } from '@material-ui/core';
import { updateDescriptionStudent } from '@webapps/business';
import {
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const editDescSchema = yup.object().shape({
  presentation: yup.string().required('Requis'),
});

const EditDescription = ({ close, presentation, refetch }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateEditDescription,
  } = useMutation(updateDescriptionStudent);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      presentation,
    },
    validationSchema: editDescSchema,
    onSubmit: async (values) => {
      await mutateEditDescription({
        data: values,
        id: idUser,
      });
    },
  });

  const [count, setCount] = React.useState(0);
  const [textarea, setTextarea] = React.useState(formik.values.presentation);

  const [countAspect, setCountAspect] = React.useState('countAspect');
  const countAspectRef = React.useRef();
  countAspectRef.current = countAspect;

  const handleSubmit = () => {
    if (!textarea) {
      formik.values.presentation = ' ';
    } else {
      formik.values.presentation = textarea;
    }
    formik.handleSubmit();
  };

  return (
    <div>
      <div
        className={classes.editorDiv}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          position: 'relative',
          marginBottom: 20,
        }}
      >
        <div className={cx(global.infoText, classes.text)}>
          Vous pouvez évoquer votre expérience, votre domaine d’activité ou vos
          compétences. Certains choisissent aussi de parler de leurs
          accomplissements ou de leurs postes précédents.
        </div>
        <CKEditor
          className={css({
            width: '100%',
            resize: 'none',
          })}
          config={{
            wordCount: {
              onUpdate: (stats) => {
                setCount(stats.characters);
              },
            },
            toolbar: ['numberedList', 'bulletedList'],
          }}
          data={textarea}
          editor={Editor}
          onChange={(event, editor) => {
            setTextarea(editor.getData());
            if (count > 200) {
              setCountAspect('countAspectPassed');
            } else {
              setCountAspect('countAspect');
            }
          }}
        />
        <div className={cx(classes[countAspectRef.current], classes.wordCount)}>
          Caractères: {count} / 200
        </div>
      </div>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            {countAspectRef.current === 'countAspect' ? (
              <Button
                className={css({ borderRadius: '400px' })}
                color="primary"
                disabled={isLoading}
                onClick={handleSubmit}
                variant="contained"
              >
                <FormattedMessage id="vitrine.btnCreate" />
              </Button>
            ) : (
              <Button
                className={css({ borderRadius: '400px' })}
                color="primary"
                disabled
                variant="contained"
              >
                <FormattedMessage id="vitrine.btnCreate" />
              </Button>
            )}
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

const styles = () => ({
  editorDiv: {
    '.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners':
      {
        border: '1px solid #C0D9FF',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#F3F7FF',
        borderBottom: 'none',
        paddingLeft: '10px',
      },
    '.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused)': {
      border: '1px solid #C0D9FF',
      borderRadius: '0 0 8px 8px',
      backgroundColor: '#F3F7FF',
      padding: '10px 20px',
      paddingBottom: '40px',
    },
    '.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners':
      {
        borderRadius: '0 0 8px 8px',
        padding: '10px 20px',
        paddingBottom: '40px',
      },
    '.ck.ck-editor': {
      width: '100%',
    },
  },
  wordCount: {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
  },
  countAspect: {
    color: '#5D75A8',
  },
  countAspectPassed: {
    color: 'red',
  },
  text: {
    marginBottom: '24px',
  },
});

EditDescription.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  presentation: PropTypes.string,
};

export default EditDescription;
